<mat-nav-list>
  <div class="logo py-2">
    <img src="./assets/data.png" alt="Company Logo" />
  </div>
  <div class="subhead"><span class="svayam">Svayam</span><span class="cat">catalog</span></div>
  <br>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/dashboard">
    <mat-icon>dashboard</mat-icon> Dashboard
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/data-discovery">
    <mat-icon>search</mat-icon> Data Discovery
  </a>

  <!-- Data Engineering Menu with Submenu -->
  <a mat-list-item (click)="isEngineeringMenuOpen = !isEngineeringMenuOpen">
    <mat-icon>edit</mat-icon> Data Engineering
    <mat-icon class="arrow-icon" [ngClass]="{ 'rotate': isEngineeringMenuOpen }">expand_more</mat-icon>
  </a>

  <div *ngIf="isEngineeringMenuOpen" style="margin-left:25px ;">
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/all-apps"  (click)="setActiveItem()">
      <mat-icon>apps</mat-icon> Apps
    </a>
    <a mat-list-item (click)="isTermMenuOpen = !isTermMenuOpen"   [ngClass]="{'list-item-active': activeItem === 'TR'}"  (click)="visitList(configurationObjectForEntites['TR'])">
      <mat-icon>description</mat-icon> Terms
      <mat-icon class="arrow-icon" [ngClass]="{ 'rotate': isEngineeringMenuOpen }">expand_more</mat-icon>
    </a>
    <div *ngIf="isTermMenuOpen" style="margin-left:25px ;">
      <a mat-list-item routerLinkActive="list-item-active"  routerLink="/cl"  (click)="setActiveItem()">
        <mat-icon>label</mat-icon> Classification
      </a>
      <a mat-list-item routerLinkActive="list-item-active" routerLink="/hier" (click)="setActiveItem()">
        <mat-icon>account_tree</mat-icon> Hierarchy
      </a>
    </div>





    <a mat-list-item routerLinkActive="list-item-active"  [ngClass]="{'list-item-active': activeItem === 'PF'}"  (click)="visitList(configurationObjectForEntites['PF'])">
      <mat-icon>book</mat-icon> Physical File
    </a>

  </div>

  <a mat-list-item>
    <mat-icon>security</mat-icon> Data Governance
  </a>
</mat-nav-list>
